// Animated thumbs-up for customer payment confirmations: spring pop, ring draw, thumb nod, sparkle burst.
const SPARKS = [-90, -30, 30, 90, 150, 210];

export default function ThumbsUpBurst({ size = 88, testId = "thumbs-up-burst" }) {
  return (
    <div className="relative mx-auto" style={{ width: size, height: size }} data-testid={testId}>
      <svg viewBox="0 0 140 140" className="absolute pointer-events-none" style={{ inset: "-12%", width: "124%", height: "124%" }} aria-hidden="true">
        <circle className="cedi-ring" cx="70" cy="70" r="66" fill="none" stroke="#34C759" strokeWidth="3" strokeLinecap="round" transform="rotate(-90 70 70)" />
      </svg>
      {SPARKS.map((deg, i) => {
        const r = (deg * Math.PI) / 180;
        return (
          <span key={deg} className="thumb-spark absolute left-1/2 top-1/2 w-2 h-2 rounded-full"
            style={{ "--dx": `${Math.cos(r) * size * 0.78}px`, "--dy": `${Math.sin(r) * size * 0.78}px`, animationDelay: `${380 + i * 30}ms`, background: i % 2 ? "#D4A853" : "#4F988E" }} aria-hidden="true" />
        );
      })}
      <div className="thumb-pop relative w-full h-full rounded-full bg-gradient-to-br from-[#5EDB7E] to-[#28A745] shadow-[0_10px_24px_rgba(52,199,89,0.35)] flex items-center justify-center">
        <svg viewBox="0 0 24 24" className="thumb-nod w-[52%] h-[52%]" fill="#FFFFFF" role="img" aria-label="Thumbs up">
          <path d="M2 10.5h3.5V21H2zM7 21h9.6c1 0 1.9-.7 2.1-1.7l1.5-6.6A2 2 0 0 0 18.2 10.3H13.6l.7-3.6a2 2 0 0 0-.5-1.8l-.9-.9L7 10.4z" />
        </svg>
      </div>
    </div>
  );
}
